export const appConfig = {
    // MEMBER REGISTRATION
    use_ssn_flag: false,
    use_dob_flag: true,
    use_member_last_name_flag: true,
    // PROVIDER DIRECTORY
    use_provider_directory_api: true,
    // FORMULARY
    use_formulary: true,
    // FHIR RESOURCES
    use_eob_member_responsibility: true,
    // EOB CUSTOMIZATIONS
    use_eob_total: true,
    // ENABLE/DISABLE SSO FIELDS
    use_sso: false,
    // SHOW PAGES
    show_help: true,
    show_developers: true,
    show_terms: true,
    // SHOW CONTENT
    show_footer_links: true,
    // CUSTOM LINKS
    developer_link: null,
    available_apps_link: null,
    login_link: null,
    // CUSTOM CONTENT
    custom_login_content: null,
    custom_login_label: null,
    // CLINICAL DATA    
    clinical_fhir_data: [
        {
            label: 'Allergies',
            resource: 'AllergyIntolerance',
            show: false,
        },
        {
            label: 'Care Plans',
            resource: 'CarePlan',
            show: false,
        },
        {
            label: 'Care Teams',
            resource: 'CareTeam',
            show: true,
        },
        {
            label: 'Conditions',
            resource: 'Condition',
            show: true,
        },
        {
            label: 'Diagnostic Reports',
            resource: 'DiagnosticReport',
            show: false,
        },
        {
            label: 'Encounters',
            resource: 'Encounter',
            show: true,
        },
        {
            label: 'Goals',
            resource: 'Goal',
            show: false,
        },
        {
            label: 'Immunizations',
            resource: 'Immunization',
            show: false,
        },
        {
            label: 'Medications',
            resource: 'MedicationRequest',
            show: true,
        },
        {
            label: 'Observations',
            resource: 'Observation',
            show: true,
        },
        {
            label: 'Procedures',
            resource: 'Procedure',
            show: true,
        },
    ],
    // AVAILABLE APPS
    available_apps_flexpa: true,
    show_reregister_message: false,


    // TERMS LINK
    terms_and_conditions_link: '/terms',

    // LABELS
    terms_and_conditions_label: 'I have reviewed and agreed to the ',
    fhir_api_label: 'I have reviewed the ',
    smart_fhir_documentation_label: 'I have reviewed the ',
    carin_code_label: 'I have reviewed and agreed to the ',
    registration_label: 'I am registering for myself.'

}